import React from 'react'

export default function AdminNotification() {
  return (
    <div className=' p-3 md:pl-[16em] lg:pl-[16em] lg:pr-[1em] xl:pl-[17em] xl:pr-[2em] w-full pt-[1em] '>
                <div className=' w-full flex justify-between items-center'>
<p className=' font-[Archivo] lg:text-2xl font-semibold'>Notifications</p>
</div>

<div>
    </div>
    </div>
  )
}
